import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable, Signal } from '@angular/core';
import { APP_CONFIG, AppConfig } from '@shared/index';
import { firstValueFrom } from 'rxjs';
 
export interface TenantIDPInfo{
  tenant_id:string,
  firebase_tenant_id:string,
  identity_providers:string[]
}
 
@Injectable({

  providedIn: 'root'

})

export class DomainService {

  constructor(@Inject(APP_CONFIG) private config:Signal<AppConfig | null>,private http:HttpClient){

  }
 
  // getTenant(): string {
 
  //   const hostname = window.location.hostname;
  //   console.log(hostname);
    
 
  //   // const subdomain = hostname.split('.')[0];
 
  //   // return subdomain.split('-')[0];
  //   return "google";
 
  // }
  getTenantInfo(): Promise<string> {
    const hostname = window.location.hostname;
    console.log("hostname:", hostname);
  
    return Promise.resolve("google");
  }

  getTenant(){
    let info:TenantIDPInfo|null=null;
    let apiUrl=this.config()?.csesServiceUrl +"authentication/tenant-idp-info/";
    let params=new HttpParams().set("tenant_slug","dev.ncxai.app");
    return firstValueFrom(
    this.http.get<TenantIDPInfo>(apiUrl, { params })
  );

    //  let info:TenantIDPInfo|null=null;
    //  info={
    //   firebase_tenant_id:"cognizant1-d31r6",
    //   identity_providers:['Google'],
    //   tenant_id:""
    //  };

    //  return Promise.resolve(info);

    
  }
 
}
